import { useCreateSiteControllerSettingTemairazuFormModel } from "../use-create-model/use-create-model";

import type { SiteControllerSettingBaseFormModel } from "../../../base/type";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../base/use-case/use-create-model/use-create-model";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
};

export const useInitialized = ({ viewModel, onSetViewModel }: Props) => {
	return {
		...useCreateSiteControllerSettingTemairazuFormModel({ viewModel, onSetViewModel }),
	};
};
